export const WHITELABEL_LOGO_MODE = {
  NONE: "none",
  STANDALONE: "standalone",
  WITH_MOLE: "withMole",
};

export const WHITELABEL_SIDENAV_LAYOUT = {
  FOOTER: "footer",
  HORIZONTAL: "horizontal",
  NONE: "none",
};

export const WHITELABEL_LOGO_MODE_ORDER = [
  WHITELABEL_LOGO_MODE.WITH_MOLE,
  WHITELABEL_LOGO_MODE.STANDALONE,
  WHITELABEL_LOGO_MODE.NONE,
];

export const WHITELABEL_SIDENAV_LAYOUT_ORDER = [
  WHITELABEL_SIDENAV_LAYOUT.FOOTER,
  WHITELABEL_SIDENAV_LAYOUT.HORIZONTAL,
  WHITELABEL_SIDENAV_LAYOUT.NONE,
];

export const getWhitelabelLogoModeOptions = (t) =>
  WHITELABEL_LOGO_MODE_ORDER.map((value) => ({
    value,
    label: t(`companies.form.whitelabelFields.logoMode.options.${value}`),
    description: t(
      `companies.form.whitelabelFields.logoMode.descriptions.${value}`,
    ),
  }));

export const getWhitelabelSidenavLayoutOptions = (t) =>
  WHITELABEL_SIDENAV_LAYOUT_ORDER.map((value) => ({
    value,
    label: t(`companies.form.whitelabelFields.sidenavLogoLayout.options.${value}`),
    description: t(
      `companies.form.whitelabelFields.sidenavLogoLayout.descriptions.${value}`,
    ),
  }));
